import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import { Actions as PAYPERIODACTIONS } from "../../../store/actions/payPeriodActions";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import { format, subDays, addDays } from "date-fns";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BillingRow from "../../billing/BillingRow";
import { CalendarIcon } from "@/icons/outline";
import { Link } from "react-router-dom";
import InvalidPermissions from "../../company-pages/InvalidPermissions";
import {
	MinusIcon,
	PlusIcon,
	ArrowsRightLeftIcon,
	ArrowUpRightIcon,
	CreditCardIcon,
	Cog8ToothIcon,
	ChevronDownIcon,
	CheckCircleIcon,
} from "@heroicons/react/20/solid";

import LoadingContent from "../../common/LoadingContent";
import PaymentMethods from "../../billing/SelectDefaultPaymentMethod";
import _ from "lodash";
import cleanDeep from "clean-deep";
import { NotificationManager } from "react-notifications";

const Billing = ({
	userPermissions,
	showPricingModal,
	updateCompanyDetails,
	disabled,
	selectedPlan,
	selectedMethod,
	paymentOptionsLength,
	org,
	currency,
	forDashboard,
	archivedStatus,
	accountStatus,
	payNow,
	creditsToPay,
}) => {
	const [changeMethod, setChangeMethod] = useState();
	useEffect(() => {
		if (!selectedMethod && !forDashboard) setChangeMethod(true);
	}, [selectedMethod]);

	if (userPermissions === "None") return <InvalidPermissions />;
	if (!org) return <LoadingContent />;

	const save = () => {
		if (!selectedMethod?.value) {
			NotificationManager.error("Payment Method cannot be empty", "Saving Payment Method");
			return;
		}
		updateCompanyDetails(
			cleanDeep(
				{
					org: String(org),
					defaultCard: selectedMethod.value,
				},
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);
		setChangeMethod(false);
	};

	return (
		<React.Fragment>
			{accountStatus != "Suspended" && (
				<div className="col-lg-12 col-xs-12 form-section">
					<div className={`col-xs-12 form-container`}>
						<div className="pull-left">
							<h4>
								{selectedPlan?.name} Plan
								<div
									className="chip"
									style={{ background: "#ffdecd", color: "#ea611c" }}
								>
									Monthly
								</div>
							</h4>
							<p style={{ color: "#4d555d" }}>{selectedPlan?.description}</p>
						</div>
						<div className="pull-right">
							{archivedStatus != "Archived" ? (
								<h1 className="leading-text">
									{" "}
									{currency}
									{selectedPlan?.price}
									<span className="sub-text">per active employee</span>
								</h1>
							) : (
								<h1>
									<span className="sub-text">This company is currently archived.</span>
								</h1>
							)}
						</div>
						<div className="clearfix form-split"></div>
						<div className="pull-right">
							<a
								className="open-text"
								onClick={() => showPricingModal()}
							>
								Upgrade Plan <ArrowUpRightIcon style={{ height: "2.5rem", verticalAlign: "middle" }} />{" "}
							</a>
						</div>
					</div>
				</div>
			)}
			<div className="col-lg-12 col-xs-12 form-section">
				<div className="col-xs-12">
					<div className="pull-left">
						<h4>Payment Method</h4>
						<p style={{ color: "#4d555d" }}>Change how you pay for your plan</p>
					</div>
					{!forDashboard && paymentOptionsLength && selectedMethod ? (
						<div
							className="btn btn-default pull-right"
							style={{ paddingRight: 6 }}
							onClick={() => setChangeMethod(!changeMethod)}
						>
							<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Switch Payment Method</div>
							<ChevronDownIcon
								style={{
									height: "1.5em",
									float: "left",
									transform: changeMethod ? "rotate(180deg)" : "rotate(0deg)",
									transition: "transform 0.2s ease-in-out",
								}}
							/>
						</div>
					) : null}
				</div>
				{changeMethod ? (
					<PaymentMethods />
				) : (
					<div
						className="col-xs-12"
						style={{ marginBottom: "2rem" }}
					>
						<div className="pull-left">
							<div
								className="chip"
								style={{ background: "#ffdecd", marginRight: "2rem" }}
							>
								<CreditCardIcon style={{ height: "2.5rem", color: "#ea611c" }} />
							</div>
						</div>
						<div className="pull-left">
							{selectedMethod ? (
								<>
									<span className="sup-text">
										{selectedMethod?.brand
											?.split(" ")
											?.map((c) => c[0].toUpperCase() + c.substring(1).toLowerCase())
											.join(" ")}{" "}
										ending in {selectedMethod?.last4}
									</span>
									<p className="sub-text">Expires on {selectedMethod?.expiry}</p>
								</>
							) : (
								<>
									<span className="sup-text">No Payment Methods Found</span>
									<p className="sub-text">Add one in Company Settings</p>
								</>
							)}
						</div>
						{forDashboard ? (
							<Link
								to="/organisation/settings/billing"
								className="btn btn-default pull-right"
							>
								<Cog8ToothIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 3 }}>Billing Settings</div>
							</Link>
						) : null}

						{creditsToPay && (
							<div
								className="btn-primary btn pull-right"
								onClick={() => payNow()}
							>
								Pay {currency}
								{creditsToPay} Pending Balance
							</div>
						)}
					</div>
				)}
				<div className="clearfix" />
			</div>
			{!forDashboard ? (
				<div
					className="col-xs-12 text-right"
					style={{ paddingRight: 0 }}
				>
					{!disabled && (
						<button
							className="btn btn-default btn-success"
							style={{ marginRight: "5" }}
							type="submit"
							onClick={() => save()}
						>
							<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Save</div>
						</button>
					)}
				</div>
			) : null}
			<div className="clearfix" />
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
    const userPermissions = state?.permissions?.my?.permissions?.billing

    const paymentOptions = state.payment.stripe && state.payment.stripe.paymentMethods && state.payment.stripe.paymentMethods.map(item => ({
        value: item.id,
        label: `•••• •••• •••• ${item.card.last4} - ${item.card.exp_month}/${item.card.exp_year}`,
        brand: item.card.brand,
        last4: item.card.last4,
        expiry: `${item.card.exp_month}/${item.card.exp_year}`,
        email: item.billing_details.email,
        phone: item.billing_details.phone
    }))

    const bundles = state.payment.bundles && _.orderBy(state.payment.bundles.filter(b => b.isPlan), ['credits'], ['asc'])

    const currency = state.company?.settings?.currency
    const planOptions = bundles?.map(item => ({
        ...item,
        value: item.id,
        label: `${item.name} - ${currency}${item.price}/employee/mo`,
    }))
    const selectedPlan = planOptions?.find(item => item.value == state.company?.settings?.plan)
    const selectedMethod = paymentOptions?.find(item => item.value == state.company?.settings?.defaultCard)

    return {
        org: state.company?.settings?.org,
        disabled: (userPermissions == 'Read'),
        selectedPlan,
        paymentOptionsLength: paymentOptions?.length > 0,
        selectedMethod,
        userPermissions,
        // businessDetails: state?.payment?.stats?.businessDetails,
        addNewCard: state.payment.stripe && state.payment.stripe.addNewCard,
        stripePaymentMethods: state.payment.stripe && state.payment.stripe.paymentMethods,
        paymentIntent: state.payment.stripe && state.payment.stripe.paymentIntent,
        processingStripeCharge: state.payment.stripe && state.payment.stripe.processingCharge,
        archivedStatus: state?.company?.settings?.status,
        currency,
        bundles,
        planOptions,
        accountStatus: state?.company?.settings?.status,
        // credits to pay is the negative credit balance, or false if there is no credit balance
		creditsToPay: !!state.payment?.stats?.creditBalance && state.payment?.stats?.creditBalance < 0 ? -state.payment?.stats?.creditBalance: false,
    }
}

const mapDispatchToProps = dispatch => ({
    showPricingModal: (isNew) => dispatch(PAYMENTACTIONS.showPricingModal(true, isNew ?? false)),
    getCredits: ({ before, after }) => dispatch(PAYMENTACTIONS.getCredits({ before, after })),
    getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
    setBillingModal: (billingModal) => dispatch(COMPANYACTIONS.setBillingModal(billingModal)),
    getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
    updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body)),
    payNow: () => dispatch(PAYMENTACTIONS.payNow()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Billing)